import React from "react";
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";

export default class RegisterStepBreadCrumbs extends React.PureComponent
{
    static propTypes = {
        language: PropTypes.string.isRequired,
        customerName: PropTypes.string.isRequired,
        positionListLink: PropTypes.string.isRequired,
        positionLink: PropTypes.string,
        positionName: PropTypes.string,
    };

    static defaultProps = {
        positionName: null,
        positionLink: null
    };

    render() {
        return (
            <div className="job-title-and-info">
                <div className="title">
                    <div className="breadcrumb-area">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to={this.props.positionListLink}>
                                    <i className="fa fa-home"/>
                                </Link>
                            </li>
                            {this.props.positionLink &&
                            <li className="breadcrumb-item">
                                <Link to={this.props.positionLink}>
                                    {this.props.positionName}
                                </Link>
                            </li>
                            }
                        </ol>
                        <h1>{window.Translator.getSlug(this.props.positionLink ? 'ApplyForPosition' : 'RegisterToGlobalPool', this.props.language)}</h1>
                    </div>
                </div>
            </div>
        );
    }
}